<template>
  <div class="score-page">
    <login-after-head></login-after-head>
    <head-nav-bar></head-nav-bar>
    <div class="container score-container">
      <div class="score-breadcrumb">
        <router-link to="/score">积分商城</router-link>
        <span> / </span>
        <span>商品详情</span>
      </div>
      <div v-loading="loading" class="detail-card">
        <div v-if="productInfo.id" class="detail-main">
          <div class="gallery">
            <div class="gallery-main">
              <img :src="currentImage" :alt="productInfo.storeName || '积分商品'">
            </div>
            <div class="gallery-thumbs">
              <button
                v-for="(image, index) in imageList"
                :key="image + index"
                type="button"
                :class="{ active: currentImage === image }"
                @click="currentImage = image"
              >
                <img :src="image" alt="商品缩略图">
              </button>
            </div>
          </div>
          <div class="detail-info">
            <span v-if="isSeckill" class="detail-tag">积分秒杀</span>
            <span v-if="productInfo.isBenefit === 1" class="detail-tag benefit">品宣商品</span>
            <h1>{{ displayName }}</h1>
            <p class="reference-price">商品参考价：￥{{ productInfo.price || 0 }}</p>
            <div class="point-panel">
              <template v-if="hasSeckillPrice">
                <span class="point-current">{{ seckillIntegral }} 积分秒杀</span>
                <span class="point-origin">{{ integral }}积分</span>
              </template>
              <span v-else class="point-current">{{ integral }}积分</span>
            </div>
            <p v-if="isSeckill" class="stock-text" :class="{ 'stock-empty': seckillStock <= 0 }">
              {{ seckillStock > 0 ? '秒杀剩余库存 ' + seckillStock : '秒杀库存 已抢完' }}
            </p>
            <p v-else class="stock-text" :class="{ 'stock-empty': stock <= 0 }">库存：{{ stock }}</p>
            <div v-if="canRedeem" class="quantity-row">
              <span>兑换数量</span>
              <button type="button" @click="decrease">-</button>
              <input v-model.number="quantity" type="number" min="1" :max="maxStock" @change="normalizeQuantity">
              <button type="button" @click="increase">+</button>
            </div>
            <div class="settlement-info">
              <p>结算价：￥{{ totalPoints }}</p>
              <p>当前账户：￥{{ balance }} 积分</p>
              <p class="available-points">
                当前可用：￥{{ availableIntegral }} 积分
                <span v-if="integralLimit">*限制品宣：￥{{ integralLimit }} 积分</span>
              </p>
            </div>
            <button
              type="button"
              class="redeem-button"
              :disabled="!canRedeem || insufficientPoints || submitting"
              @click="redeem"
            >
              {{ insufficientPoints ? '积分不足' : (submitting ? '处理中...' : redeemText) }}
            </button>
          </div>
        </div>
        <div v-else-if="!loading" class="empty-detail">商品不存在或已下架</div>
        <div v-if="productInfo.id" class="description-section">
          <h2>商品详情</h2>
          <div class="description-content" v-html="descriptionHtml"></div>
        </div>
      </div>
    </div>
    <i-footer></i-footer>
    <fixed-right></fixed-right>
  </div>
</template>

<script>
import { addIntegralCart, getIntegral, getIntegralLimit, getIntegralProductDetail } from '@/api/score'

export default {
  name: 'ScoreDetails',
  data () {
    return {
      productInfo: {},
      balance: 0,
      integralLimit: 0,
      quantity: 1,
      currentImage: '',
      loading: true,
      submitting: false
    }
  },
  computed: {
    imageList () {
      const images = this.productInfo.sliderImageArr || []
      if (images.length) return images
      return this.productInfo.image ? [this.productInfo.image] : [require('../assets/noll.png')]
    },
    displayName () {
      if (this.isSeckill && this.productInfo.storeSeckill.title) {
        return this.productInfo.storeSeckill.title
      }
      return this.productInfo.storeName || '--'
    },
    isSeckill () {
      return Number(this.productInfo.isSeckill) === 1 && Boolean(this.productInfo.storeSeckill)
    },
    integral () {
      return Number((this.productInfo.attrInfo && this.productInfo.attrInfo.integral) ||
        this.productInfo.integral || 0)
    },
    seckillIntegral () {
      return Number((this.productInfo.attrInfo && this.productInfo.attrInfo.seckillIntegral) ||
        (this.productInfo.storeSeckill && this.productInfo.storeSeckill.integral) || this.integral)
    },
    hasSeckillPrice () {
      return this.isSeckill && Number(this.productInfo.attrInfo &&
        this.productInfo.attrInfo.seckillIntegral || 0) > 0
    },
    stock () {
      return Math.max(Number(this.productInfo.stock || 0), 0)
    },
    seckillStock () {
      return Math.max(Number(this.productInfo.attrInfo && this.productInfo.attrInfo.seckillStock || 0), 0)
    },
    maxStock () {
      return this.isSeckill ? this.seckillStock : this.stock
    },
    pointPrice () {
      return this.hasSeckillPrice ? this.seckillIntegral : this.integral
    },
    descriptionHtml () {
      if (this.isSeckill && this.productInfo.storeSeckill.description) {
        return this.productInfo.storeSeckill.description
      }
      return this.productInfo.description || '暂无商品详情'
    },
    redeemText () {
      if (this.hasSeckillPrice && this.seckillStock > 0) return '马上秒杀'
      if (this.isSeckill && this.seckillStock <= 0) return '已抢完'
      return '立即兑换'
    },
    totalPoints () {
      return this.pointPrice * this.quantity
    },
    availableIntegral () {
      const balance = Number(this.balance || 0)
      if (Number(this.productInfo.isBenefit) === 1) return balance
      return Math.max(balance - Number(this.integralLimit || 0), 0)
    },
    insufficientPoints () {
      return this.totalPoints > this.availableIntegral
    },
    canRedeem () {
      return Number(this.productInfo.isShow) === 1 && this.maxStock > 0
    }
  },
  watch: {
    imageList: {
      immediate: true,
      handler (images) {
        this.currentImage = images[0]
      }
    }
  },
  mounted () {
    const id = this.$route.query.id
    if (!id) {
      this.loading = false
      return
    }
    Promise.all([
      getIntegralProductDetail(id),
      getIntegral(),
      getIntegralLimit()
    ]).then(([productRes, balanceRes, limitRes]) => {
      this.productInfo = productRes.data || {}
      this.balance = Number(balanceRes.data || 0)
      this.integralLimit = Number(limitRes.data || 0)
    }).catch(error => {
      this.$message.warning((error && error.msg) || '积分商品加载失败，请重试')
    }).finally(() => {
      this.loading = false
    })
  },
  methods: {
    normalizeQuantity () {
      const quantity = Number(this.quantity) || 1
      this.quantity = Math.min(Math.max(quantity, 1), this.maxStock || 1)
    },
    decrease () {
      this.quantity = Math.max(this.quantity - 1, 1)
    },
    increase () {
      this.quantity = Math.min(this.quantity + 1, this.maxStock)
    },
    redeem () {
      this.normalizeQuantity()
      if (!this.canRedeem || this.insufficientPoints || this.submitting) return
      const attrInfo = this.productInfo.attrInfo || {}
      const data = {
        productId: this.productInfo.id,
        cartNum: this.quantity,
        isIntegral: 1,
        new: 1,
        uniqueId: attrInfo.unique
      }
      if (this.isSeckill && this.productInfo.storeSeckill.id) {
        data.secKillId = this.productInfo.storeSeckill.id
      }
      this.submitting = true
      addIntegralCart(data).then(res => {
        const cartId = res.data && res.data.cartId
        if (!cartId) throw new Error('积分兑换购物车创建失败')
        this.$router.push({ path: '/integralSubmit', query: { cartId } })
      }).catch(error => {
        this.$message.warning((error && error.msg) || error.message || '兑换失败，请重试')
      }).finally(() => {
        this.submitting = false
      })
    }
  }
}
</script>

<style scoped lang="less">
.score-container {
  padding-bottom: 30px;
}
.score-breadcrumb {
  height: 54px;
  display: flex;
  align-items: center;
  color: #999;
  font-size: 13px;
}
.score-breadcrumb a {
  color: #57aca7;
}
.detail-card {
  min-height: 500px;
  padding: 30px;
  border: 1px solid #eee;
  background: #fff;
}
.detail-main {
  display: flex;
  gap: 50px;
}
.gallery {
  width: 470px;
  flex: 0 0 470px;
}
.gallery-main {
  height: 420px;
  background: #fafafa;
}
.gallery-main img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.gallery-thumbs {
  display: flex;
  gap: 10px;
  margin-top: 14px;
}
.gallery-thumbs button {
  width: 64px;
  height: 64px;
  padding: 3px;
  border: 1px solid #eee;
  background: #fff;
  cursor: pointer;
}
.gallery-thumbs button.active {
  border-color: #57aca7;
}
.gallery-thumbs img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.detail-info {
  flex: 1;
  padding-top: 10px;
}
.detail-tag {
  display: inline-block;
  margin-right: 8px;
  padding: 4px 8px;
  background: #e43d33;
  color: #fff;
  font-size: 12px;
}
.detail-tag.benefit {
  background: #57aca7;
}
.detail-info h1 {
  margin-top: 18px;
  color: #333;
  font-size: 26px;
  font-weight: 500;
  line-height: 1.5;
}
.reference-price {
  margin-top: 18px;
  color: #999;
}
.point-panel {
  margin-top: 20px;
  padding: 18px 20px;
  background: #f7fbfa;
}
.point-current {
  color: #e43d33;
  font-size: 28px;
  font-weight: 600;
}
.point-origin {
  margin-left: 15px;
  color: #999;
  text-decoration: line-through;
}
.stock-text {
  margin: 18px 0 0;
  color: #666;
  font-size: 14px;
  line-height: 24px;
}
.stock-text.stock-empty {
  color: #e43d33;
}
.settlement-info {
  margin-top: 18px;
  color: #999;
  font-size: 14px;
  line-height: 28px;
}
.settlement-info p {
  margin: 0;
}
.settlement-info .available-points {
  color: #e43d33;
}
.settlement-info .available-points span {
  margin-left: 8px;
}
.quantity-row {
  display: flex;
  align-items: center;
  gap: 0;
  margin-top: 24px;
  color: #666;
}
.quantity-row button,
.quantity-row input {
  width: 36px;
  height: 32px;
  box-sizing: border-box;
  border: 1px solid #ddd;
  background: #fff;
  text-align: center;
}
.quantity-row span {
  margin-right: 20px;
}
.quantity-row input {
  border-left: 0;
  border-right: 0;
}
.redeem-button {
  width: 180px;
  height: 44px;
  margin-top: 28px;
  border: 1px solid #57aca7;
  background: #57aca7;
  color: #fff;
  cursor: pointer;
}
.redeem-button:disabled {
  cursor: not-allowed;
  opacity: .55;
}
.description-section {
  margin-top: 40px;
  border-top: 1px solid #eee;
}
.description-section h2 {
  padding: 20px 0;
  color: #333;
  font-size: 18px;
  font-weight: 500;
}
.description-content {
  overflow: hidden;
  line-height: 1.8;
}
.description-content /deep/ img {
  max-width: 100%;
}
.empty-detail {
  padding: 160px 0;
  color: #999;
  text-align: center;
}
</style>
